const title = 'BasicEx全球领先的加密货币支付服务商'

export default function getPageTitle(pageTitle: any) {
    if(pageTitle) {
        return `${pageTitle}-${title}`
    }
    return `${title}`
}